import { createContext, useContext, useMemo, type ReactNode } from "react";

export type AdminStatus = "demo";
type AuthResult = { ok: boolean; message?: string };

interface AdminContextValue {
  /** "checking" enquanto valida a sessão, "guest" visitante, "admin" autorizado, "denied" sem permissão. */
  status: AdminStatus;
  /** Indica se a autenticação segura já está conectada. */
  configured: boolean;
  /** E-mail conectado (quando houver). */
  email: string | null;
  /** Permissão global de edição. Só é `true` para um `vellora_admin` validado. */
  canEdit: boolean;
  notConnectedMessage: string;
  sendLink: (email: string) => Promise<AuthResult>;
  signOut: () => Promise<void>;
}

const AdminContext = createContext<AdminContextValue | null>(null);

export function AdminProvider({ children }: { children: ReactNode }) {
  const demoMessage = "Demonstração local do painel: os recursos são apresentados sem depender de banco de dados ou login.";
  const value = useMemo<AdminContextValue>(
    () => ({
      status: "demo",
      configured: false,
      email: null,
      canEdit: false,
      notConnectedMessage: demoMessage,
      sendLink: async () => ({ ok: false, message: demoMessage }),
      signOut: async () => undefined,
    }),
    [],
  );

  return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
}

export function useAdmin(): AdminContextValue {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error("useAdmin precisa estar dentro de AdminProvider.");
  }
  return context;
}
